import lottie from 'lottie-web';
import { resizeScroll, getScrollInstance } from '../core/ScrollService.js';

const loaded = new WeakSet();

const mountLottie = (elt) => {
    if (loaded.has(elt)) return;
    const url = elt.getAttribute('data-url');
    if (!url) return;

    loaded.add(elt);

    const anim = lottie.loadAnimation({
        container: elt,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: url,
    });

    anim.addEventListener('data_ready', () => {
        if (getScrollInstance()) {
            resizeScroll();
        }
    });
};

const initLotties = () => {
    const nodes = Array.from(document.querySelectorAll('.lottie[data-url]'));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
        nodes.forEach(mountLottie);
        return;
    }

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                mountLottie(entry.target);
                io.unobserve(entry.target);
            });
        },
        { rootMargin: '200px 0px', threshold: 0.01 }
    );

    nodes.forEach((elt) => io.observe(elt));
};

export { initLotties };
